import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

import School from "./components/b2school.vue";
import thirdsect from "./components/reels.vue";
import Footer from "./components/footer.vue";
import Download from "./components/getapp.vue";
import Stores from "./components/stores.vue";
import landing from "./components/landing.vue";
import Arrival from "./components/arrivals.vue";
import Campaign from "./components/campaign.vue";
import Cfc from "./components/funclub.vue";
import Collab from "./components/collab.vue";
import Feature from "./components/featured.vue";
import { split } from "./animations/split";
import { onMounted } from "vue";
import { ref } from "@vue/reactivity";
import Preloader from "./components/preloader.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const showPreloader = ref(true);
const removePreloader = () => {
     showPreloader.value = false;
};
onMounted(() => {
     split();
     window.scrollTo(0, 0);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (showPreloader.value)
          ? (_openBlock(), _createBlock(Preloader, {
              key: 0,
              onFadeOut: removePreloader
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(landing),
    _createVNode(Campaign),
    _createVNode(Arrival),
    _createVNode(Collab),
    _createVNode(Feature),
    _createVNode(thirdsect),
    _createVNode(School),
    _createVNode(Cfc),
    _createVNode(Download),
    _createVNode(Stores),
    _createVNode(Footer)
  ], 64))
}
}

})